export default "__VITE_ASSET__B6jCf1HC__"